<section class="order-only-section">
  <div class="qr-only-text">
   {{restaurant.qrCodeOrderingOnlyErrorMessage}}
  </div>
</section>
